<template>
  <div id="form-menu">
    <h2>
      <span v-if="editingMode === 'edit'">Editar</span>
      <span v-if="editingMode === 'create'">Novo</span> Menu
    </h2>
    <br />
    <b-container>
      <b-tabs class="mt-4 w-100">
        <b-tab title="Português">
          <translation-menu v-bind.sync="editingCache" :disabledInputs="disabledInputs" />
        </b-tab>
        <b-tab title="Inglês">
          <translation-menu v-bind.sync="editingCache" :disabledInputs="disabledInputs" />
        </b-tab>
        <b-tab title="Francês">
          <translation-menu v-bind.sync="editingCache" :disabledInputs="disabledInputs" />
        </b-tab>
        <b-tab title="Espanhol">
          <translation-menu v-bind.sync="editingCache" :disabledInputs="disabledInputs" />
        </b-tab>
      </b-tabs>
    </b-container>
    <br />
    <div v-if="editingMode !== 'view'">
      <b-button
        variant="primary"
        @click="editingMode === 'edit' ? updateMenu(editingCache.id) : createMenu()"
        :disabled="errors.count() > 0"
      >Submeter</b-button>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import { mapMutations, mapActions } from "vuex";
import translationsMenu from "./translationsMenu";
export default {
  name: "formMenu",
  props: {
    editingMode: { type: String, required: true },
    menu: { type: Object }
  },
  components: {
    "translation-menu": translationsMenu
  },
  data() {
    return {
      editingCache: {
        title: "",
        subtitle: "",
        description: ""
      }
    };
  },
  computed: {
    disabledInputs() {
      return this.editingMode === "view";
    }
  },
  mounted() {
    if (this.editingMode !== "create") {
      this.editingCache = Object.assign({}, this.menu);
      delete this.editingCache["meals"];
    }
  },
  methods: {
    ...mapMutations(["showNotice"]),
    ...mapActions(["refreshMenus"]),
    createMenu() {
      api.newMenu({ ...this.editingCache, establishmentID: 1 }).then(() => {
        this.refreshMenus();
        this.showNotice({ newMessage: "Menu criado", type: "success" });
      });
    },
    updateMenu(id) {
      api.updateMenu({ id: id }, this.editingCache).then(() => {
        this.refreshMenus();
        this.showNotice({ newMessage: "Menu atualizado", type: "success" });
      });
    }
  }
};
</script>

<style lang='css'>
#new-menu label {
  text-align: left;
}
.errors-list {
  color: red;
  list-style-type: none;
}
</style>
